import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { colors } from '../../styles/colors'
import { getFormatedData } from '../../functions/getFormatedData'

const Container = styled.div`
    width: 100%;
    position: relative;
    height: ${props => props.focus ? '70px' : '40px'};

    .search-ico {
        position: absolute;
        top: ${props => props.focus ? '15px' : '0px'};
        left: ${props => props.focus ? '5.25rem' : '0'};
        cursor: ${props => props.focus ? 'auto' : 'pointer'};
        pointer-events: none;
        
        svg {
            transition: all .5s;
            
            path{
                fill: ${props => props.focus ? colors.white : colors.dark_blue};
            }
            ellipse{
                transition: all .5s;
                fill: ${props => props.focus ? colors.dark_blue : colors.white};
            }
        }

        @media (max-width: 320px) {
            top: ${props => props.focus ? '15px' : '0px'};
            left: ${props => props.focus ? '10px' : '0px'};    
        }
    }
    .search-input {
        width: ${props => props.focus ? '100%' : '30px'};
        height: 100%;
        margin: 0;

        border: none;
        outline: none;
        background: ${props => props.focus ? colors.dark_blue : 'none'};

        padding-left: ${props => props.focus ? '108px' : '0'};

        color: ${colors.white};
        cursor: ${props => props.focus ? 'auto' : 'pointer'};
        
        font-family: 'SF UI Text Light', sans-serif;
        font-size: 2.5rem;
        letter-spacing: .25rem;

        transition: width .5s;

        ::placeholder {
            color: ${colors.white};
        }

        @media (max-width: 320px) {
            padding-left: ${props => props.focus ? '60px' : '0'};
        }
    }
`

export const SearchBar = () => {

    const searchingFocused = useSelector(state => state.searching.focused)

    const dispatch = useDispatch()
    const products_data = useSelector(state => state.firebase.data.products && state.firebase.data.products.products_list)
    const products = getFormatedData(products_data)

    const [input, setInput] = useState('')

    const handleInputChange = (value) => {
        setInput(value)
        const formated_input = value.trim().toLowerCase()
        const result = []

        products.map(item => {
            if (item.product_name.match(formated_input)) {
                result.push(item)
            }
            return true
        })

        if (result.length === 0) {
            dispatch({ type: 'SET_SEARCHING_RESULT', result: ['not_found'] })
        } else {
            dispatch({ type: 'SET_SEARCHING_RESULT', result })
        }

        if (value === '') {
            dispatch({ type: 'SET_SEARCHING_RESULT', result: [] })
        }

    }

    return (
        <Container className="search-bar" focus={searchingFocused}  >
            <Link to='/search' onClick={()=> window.scrollTo(0, 0) }>
                <div style={{height:'100%'}}>
                    <div className="search-ico">
                        <svg width="30" height="40" viewBox="0 0 30 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M28.9963 13.4363C28.9963 20.8569 22.5053 26.8726 14.4982 26.8726C6.49105 26.8726 0 20.8569 0 13.4363C0 6.01563 6.49105 0 14.4982 0C22.5053 0 28.9963 6.01563 28.9963 13.4363Z" fill="#00253D" />
                            <path d="M19.2938 25.752L21.8561 24.4941L30 38.7421L27.4377 40L19.2938 25.752Z" fill="#00253D" />
                            <path d="M26.0967 13.4363C26.0967 19.3728 20.9039 24.1853 14.4982 24.1853C8.09247 24.1853 2.89963 19.3728 2.89963 13.4363C2.89963 7.49976 8.09247 2.68726 14.4982 2.68726C20.9039 2.68726 26.0967 7.49976 26.0967 13.4363Z" fill="#00253D" />
                            <ellipse cx="14.4982" cy="13.4363" rx="11.5985" ry="10.749" fill="white" />
                        </svg>
                    </div>
                    <input
                    className='search-input'
                        onFocus={() => dispatch({ type: 'SEARCHING_BAR_FOCUSED' })}
                        onBlur={() => dispatch({ type: 'SEARCHING_BAR_BLURED' })}
                        onChange={e => handleInputChange(e.target.value)}
                        type="text"
                        value={input}
                        placeholder='Поиск'
                    />
                </div>
            </Link>
        </Container>
    )
}
